import { render, staticRenderFns } from "./VueEmailTemplateModal.vue?vue&type=template&id=798ae4b4&scoped=true"
import script from "./VueEmailTemplateModal.vue?vue&type=script&lang=js"
export * from "./VueEmailTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./VueEmailTemplateModal.vue?vue&type=style&index=0&id=798ae4b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798ae4b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798ae4b4')) {
      api.createRecord('798ae4b4', component.options)
    } else {
      api.reload('798ae4b4', component.options)
    }
    module.hot.accept("./VueEmailTemplateModal.vue?vue&type=template&id=798ae4b4&scoped=true", function () {
      api.rerender('798ae4b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueEmail/VueEmailTemplateModal.vue"
export default component.exports